const ROOM_TAG_COOKIE_NAME = 'room_tag_v7';
const ROOM_TAG_COOKIE_EXPIRE_DAYS = 30;
const ROOM_TAG_COOKIE_SECURED = window.location.protocol === 'https:';

export const getRoomTag = () => {
  return App.es6.shared.cookie.get(ROOM_TAG_COOKIE_NAME);
};

export const setRoomTag = (value) => {
  if (!value) {
    throw new Error(`Tried to set room tag to falsy value: "${value}"`);
  }

  App.es6.shared.cookie.set(
    ROOM_TAG_COOKIE_NAME,
    value,
    ROOM_TAG_COOKIE_EXPIRE_DAYS,
    ROOM_TAG_COOKIE_SECURED,
  );
};

/**
 * @returns {Promise<?object>} the arrival tag from the published tags list, or null when there is no
 *   cookie or the tag is no longer published
 */
const findRoomTag = () => {
  const roomTag = getRoomTag();

  if (!roomTag) {
    return Promise.resolve(null);
  }

  return App.es6.shared.tags_storage().getTags()
    .then((tags) => tags.tags.find((item) => item.data.key === roomTag) ?? null);
};

export const getPrettyRoomTag = () => findRoomTag().then((tag) => tag?.value ?? null);

export const getRoomTagEventCategory = () => findRoomTag().then((tag) => tag?.data.eventCategory ?? null);
